import { Session } from "inspector";
import { Task } from "./Task";

export class Protocol {
  id?: number;
  name: string;
  description: string;
  minDuration: number;
  sugDuration: number;
  pathology: string;
  deleted?: boolean;
  sessions: ProtocolSession[];
  therapies?: ProtocolSession[];
  createdAt?: string;
  updatedAt?: string;
  checked?: boolean;
  hours?: number;
  protocolId?: number
  isInvalid?: boolean

  constructor() {
    this.name = "";
    this.description = "";
    this.minDuration = 1;
    this.sugDuration = 1;
    this.pathology = "";
    this.sessions = [];
    this.checked = false;
  }
}

export class ProtocolSession {
  label: string;
  tasks: Task[];
  sessionName?: string;
  therapyId?: number;
  taskGroup!: number;
  sessionId!: number;
  scheduled?: Date;
  scheduledDate?: string;
  isCompleted?: number;
  id?: number;
  hours?: number;
  name?: string;

  constructor(name?: string) {
    this.label = name || "";
    this.tasks = [];
  }
}


export interface ProtocolUploadDTO {
  targets: string[];
  items: any[];
}

export interface ImportableProtocol {
  checked: boolean;
  type: string;
  object: { id: number, name: string }
}

export interface ProtocolImportDTO {
  type: "protocols",
  ids: String[];
}

export interface ProtocolResume {
  completionDate?: string;
  protocolId?: number,
  name: string,
  therapies: SessionResume[] | ProtocolSession[],
  sessions: SessionResume[] | ProtocolSession[],
  description: string;
  minDuration: number;
  sugDuration: number;
  pathology: string;
  id?: number
}

export interface ProtocolInstance {
  protocolId?: number,
  name: string,
  sessions: SessionResume[],
  id?: number
  completionDate?: Date,
}

export interface SessionResume {
  isCompleted: number;
  scheduledDate?: string;
  therapyId?: number;
  sessionId?: number,
  name: string,
  sessionName?: string
}

export interface Therapy {
  sessionId: number,
  scheduledDate: string,
  deviceId: number,
  tasks: TherapyTasks[]
}

export interface TherapyTasks {
  taskId: string,
  parameters: KeyValue[]
}
export interface KeyValue {
  key: string,
  value: string
}

export interface Schedule {
  protocolId: number,
  pathologyId?: number | string,
  therapies: Therapy[] | any[],
}